import { FadeIn } from '../../components/ui/AnimatedSection';
import { Star, Shield, Diamond, CheckCircle2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function ExclusivitySection() {
  const { t } = useTranslation();
  const items = t('home.exclusivity.items', { returnObjects: true }) as Array<{ title: string; desc: string }>;

  return (
    <section className="py-32 bg-cream-100 text-black-deep relative overflow-hidden" id="exclusivite">
      {/* Abstract luxury background */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gold-200/40 rounded-full blur-[150px] translate-x-1/3 -translate-y-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-white/60 rounded-full blur-[120px] -translate-x-1/3 translate-y-1/4"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          <FadeIn className="order-2 lg:order-1">
            <div className="relative">
              {/* Decorative elements */}
              <div className="absolute -left-6 -top-6 w-12 h-12 border-t-2 border-l-2 border-gold-300"></div>
              <div className="absolute -right-6 -bottom-6 w-12 h-12 border-b-2 border-r-2 border-gold-300"></div>
              
              <div className="bg-white border border-gray-100 p-10 md:p-14 rounded-2xl shadow-[0_20px_60px_rgba(201,152,85,0.08)] relative overflow-hidden">
                <div className="absolute top-0 right-0 p-8 opacity-5">
                  <Diamond size={120} className="text-black-deep" />
                </div>
                
                <h3 className="text-3xl font-serif mb-8 text-gold-600">{t('home.exclusivity.title1')}</h3>
                
                <div className="space-y-8">
                  <div className="flex items-start">
                    <div className="mt-1 mr-4">
                      <div className="w-10 h-10 rounded-full bg-gold-50 flex items-center justify-center border border-gold-200">
                        <Star size={16} className="text-gold-600" />
                      </div>
                    </div>
                    <div>
                      <h4 className="text-lg font-serif mb-2 text-black-deep">{items[0].title}</h4>
                      <p className="text-gray-600 text-sm font-light leading-relaxed">{items[0].desc}</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="mt-1 mr-4">
                      <div className="w-10 h-10 rounded-full bg-gold-50 flex items-center justify-center border border-gold-200">
                        <CheckCircle2 size={16} className="text-gold-600" />
                      </div>
                    </div>
                    <div>
                      <h4 className="text-lg font-serif mb-2 text-black-deep">{items[1].title}</h4>
                      <p className="text-gray-600 text-sm font-light leading-relaxed">{items[1].desc}</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="mt-1 mr-4">
                      <div className="w-10 h-10 rounded-full bg-gold-50 flex items-center justify-center border border-gold-200">
                        <Shield size={16} className="text-gold-600" />
                      </div>
                    </div>
                    <div>
                      <h4 className="text-lg font-serif mb-2 text-black-deep">{items[2].title}</h4>
                      <p className="text-gray-600 text-sm font-light leading-relaxed">{items[2].desc}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn className="order-1 lg:order-2">
            <span className="text-gold-600 tracking-[0.2em] text-xs font-bold uppercase mb-4 block flex items-center">
              <span className="w-8 h-px bg-gold-500 mr-4"></span>
              {t('home.exclusivity.tag')}
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif mb-8 leading-tight text-black-deep">
              {t('home.exclusivity.title2')} <br/>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-500 to-gold-700">{t('home.exclusivity.title3')}</span>
            </h2>
            
            <p className="text-gray-700 text-lg md:text-xl font-light leading-relaxed mb-8">
              {t('home.exclusivity.p1')}
            </p>
            <p className="text-gray-500 font-light leading-relaxed mb-10">
              {t('home.exclusivity.p2')}
            </p>
            
            <a href="/audit" className="inline-flex items-center justify-center px-10 py-4 bg-gradient-to-r from-gold-400 to-gold-600 text-white text-sm uppercase tracking-widest rounded-full shadow-[0_8px_20px_rgba(201,152,85,0.4)] hover:shadow-[0_12px_30px_rgba(201,152,85,0.6)] hover:-translate-y-1 transition-all duration-300">
              {t('home.exclusivity.btn')}
            </a>
          </FadeIn>

        </div>
      </div>
    </section>
  );
}
